/* Progressive enhancement: the complete gallery remains visible without JS. */
(() => {
  if (customElements.get('vorneel-collection-gallery')) return;

  class VorneelCollectionGallery extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-motion') ||
          window.Shopify?.designMode ||
          !('IntersectionObserver' in window) ||
          window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-entering');
          this.observer.unobserve(entry.target);
        });
      }, { threshold: 0.08 });

      this.querySelectorAll('[data-gallery-reveal]').forEach((item) => {
        this.observer.observe(item);
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.querySelectorAll('.is-entering').forEach((item) => {
        item.classList.remove('is-entering');
      });
    }
  }

  customElements.define('vorneel-collection-gallery', VorneelCollectionGallery);
})();
